import { render, staticRenderFns } from "./SearchAddressbook.vue?vue&type=template&id=57e540a0&scoped=true"
import script from "./SearchAddressbook.vue?vue&type=script&lang=js"
export * from "./SearchAddressbook.vue?vue&type=script&lang=js"
import style0 from "./SearchAddressbook.vue?vue&type=style&index=0&id=57e540a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e540a0",
  null
  
)

export default component.exports